const appConfig = {
  // minutes
  sessionTimeout: process.env.REACT_APP_SESSIONTIMEOUT || 120,
};

export default appConfig;
